import { render } from "./SunLightInstruction.vue?vue&type=template&id=3045a5a8&scoped=true"
import script from "./SunLightInstruction.vue?vue&type=script&lang=js"
export * from "./SunLightInstruction.vue?vue&type=script&lang=js"

import "./SunLightInstruction.vue?vue&type=style&index=0&id=3045a5a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3045a5a8"]])

export default __exports__